const COUPON_CARD = "coupon_card";
const COUPON_CARD_GROUP = "coupon_card_group";

const COUPON_ERROR_BOTTOM_SHEET = "coupon_error_bs";

export const COUPON_CARD_TESTS_IDS = {
    CONTAINER: `${COUPON_CARD}_container`,
    APPLY_CTA: `${COUPON_CARD}_apply_cta`,
    GROUP_TITLE: `${COUPON_CARD}_group_title`,
    FOOTER_IMAGE: `${COUPON_CARD}_footer_image`,
};

export const COUPON_CARD_GROUP_TESTS_IDS = {
    NEW_INDICATOR: `${COUPON_CARD_GROUP}_new_tag`,
};

export const COUPON_ERROR_BOTTOM_SHEET_TEST_IDS = {
    LOADER: `${COUPON_ERROR_BOTTOM_SHEET}_loader`,
    TITLE: `${COUPON_ERROR_BOTTOM_SHEET}_title`,
    CONTAINER: `${COUPON_ERROR_BOTTOM_SHEET}_container`,
    FULL_WIDTH_CTA: `${COUPON_ERROR_BOTTOM_SHEET}_full_width_cta`,
};

export const DELIGHT_POPUP_TEST_IDS = {
    POPUP: "auto-applied-delight-popup",
    CTA_BUTTON: "delight-popup-cta-button",
};
